import { forwardRef } from 'react'
import { type GrowProps, Grow } from '@mui/material'

export const GrowTransition = forwardRef<HTMLDivElement, GrowProps>(
  function GrowTransition(props, ref) {
    return <Grow ref={ref} {...props} />
  }
)
